// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__IG7zp","description":"style_description__bwleD","btnContainer":"style_btnContainer__S1ezW"};